import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { User_Service_URL } from "../Url";

export const saveDeactivateEmployeeActions = {
  SAVE_DEACTIVE_EMPLOYEE_DETAILS_SUCCESS:
    "SAVE_DEACTIVE_EMPLOYEE_DETAILS_SUCCESS",
  SAVE_DEACTIVE_EMPLOYEE_DETAILS_ERROR: "SAVE_DEACTIVE_EMPLOYEE_DETAILS_ERROR",
};

export function saveDeactiveEmployeeDetails(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/deleteCETAndRMRoleByUserId`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveDeactiveEmployeeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveDeactiveEmployeeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveDeactiveEmployeeError(err));
          return err.response;
        }
      });
}

export function saveDeactiveEmployeeError(error) {
  return {
    type: saveDeactivateEmployeeActions.SAVE_DEACTIVE_EMPLOYEE_DETAILS_ERROR,
    payload: error,
  };
}

export function saveDeactiveEmployeeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveDeactivateEmployeeActions.SAVE_DEACTIVE_EMPLOYEE_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
